
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/outdoor-course/[outdoorCourse]",
      function () {
        return require("private-next-pages/outdoor-course/[outdoorCourse].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/outdoor-course/[outdoorCourse]"])
      });
    }
  